import React, { useEffect, useState } from 'react';
import { Dialog, Image, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import { TextInput, TextValidationWrapper } from '@colonist/ui-platform';
import IconCoin from '@static/images/icon_colonist_coin.svg';
import { getUsernameValidationMessage } from './getUsernameValidationMessage.ts';
import { UsernameSuggestionList } from './UsernameSuggestionList/UsernameSuggestionList.tsx';
import { UsernameChangeStatusNote } from './UsernameChangeStatusNote/UsernameChangeStatusNote.tsx';
import { UsernamePurchaseConfirmation } from './UsernamePurchaseConfirmation/UsernamePurchaseConfirmation.tsx';
import styles from './ChangeUsernameDialog.module.scss';
/* Dialog for user to change their username */ export const ChangeUsernameDialog = ({ onCancel, input, validation, suggestions, usernameChange, title, onConfirm, onGoToStore, onLogin })=>{
    const [purchaseConfirmed, setPurchaseConfirmed] = useState(false);
    useEffect(()=>{
        setPurchaseConfirmed(false);
    }, [
        usernameChange.changeScenario
    ]);
    const isValid = validation.result.type == 'valid' && !validation.isValidating;
    const canSubmit = isValid && usernameChange.changeScenario != 'notEnoughCoins' && purchaseConfirmed;
    const validationMessage = getUsernameValidationMessage(validation.result, {
        isValidating: validation.isValidating,
        hasEdited: validation.hasEdited
    });
    const canEdit = usernameChange.changeScenario != 'login' && usernameChange.changeScenario != 'notEnoughCoins';
    const handleInputChange = (event, wrapperOnChange)=>{
        wrapperOnChange(event);
        input.onChange(event.target.value);
    };
    const handleKeyDown = (event)=>{
        if (event.key != 'Enter') return;
        if (!canSubmit) return;
        event.preventDefault();
        onConfirm();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        onClose: onCancel
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(UsernameChangeStatusNote, {
        changeScenario: usernameChange.changeScenario,
        freeChangesLeft: usernameChange.freeChangesLeft,
        colonistCoins: usernameChange.colonistCoins,
        price: usernameChange.price
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h4", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.changeUsername.body'
        }
    })), /*#__PURE__*/ React.createElement(TextValidationWrapper, {
        maxLength: input.maxLength,
        errorMessage: validationMessage
    }, ({ maxLength: wrapperMaxLength, onChange: wrapperOnChange, ref: wrapperRef })=>/*#__PURE__*/ React.createElement(TextInput, {
            ref: wrapperRef,
            value: input.value,
            onChange: (e)=>handleInputChange(e, wrapperOnChange),
            onKeyDown: handleKeyDown,
            maxLength: wrapperMaxLength,
            autoFocus: input.autoFocus,
            disabled: !canEdit,
            "data-testid": "change-username-input"
        }))), /*#__PURE__*/ React.createElement(UsernameSuggestionList, {
        suggestions: suggestions.items,
        onSelect: suggestions.onClick
    }), /*#__PURE__*/ React.createElement(UsernamePurchaseConfirmation, {
        changeScenario: usernameChange.changeScenario,
        confirmed: purchaseConfirmed,
        onConfirmedChange: setPurchaseConfirmed
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onCancel
    }), usernameChange.changeScenario == 'login' && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onLogin
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.login'
        }
    })), usernameChange.changeScenario == 'notEnoughCoins' && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onGoToStore
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.changeUsername.notEnoughCoins.checkButton'
        }
    })), usernameChange.changeScenario == 'coins' && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        disabled: !canSubmit,
        onClick: onConfirm
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.priceLabel,
        "data-testid": "username-change-price"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.coinIcon,
        image: {
            src: IconCoin,
            alt: emptyTranslation
        }
    }), /*#__PURE__*/ React.createElement("span", null, usernameChange.price))), usernameChange.changeScenario == 'free' && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        disabled: !canSubmit,
        onClick: onConfirm
    })));
};
